/* istanbul ignore file */
// All logic is located in helpers
import useListCrud from './builder/useListCrud';
import useListDataLoading from './builder/useListDataLoading';
import useListDataUpdating from './builder/useListDataUpdating';
import useListParams from './builder/useListParams';
import useListUrlStoring from './builder/useListUrlStoring';
import { Filter } from './filter/FilterContext';
import { ListProvider } from './ListContext';
import { SimpleListProps } from './SimpleList';
const LIST_PAGE_SIZE = 30;

interface ListProps extends SimpleListProps {
  defaultSortOrder?: string;
  defaultSortField?: string;
  defaultFilter?: Filter;
  pageSize?: number;
  onRemove?: (params: StringOrNumber) => void;
  uncontrolledFilters?: string[];
}

const ListWithoutStoringParams = ({
  getDataMethod,
  children,
  uncontrolledFilters,
  pageSize = LIST_PAGE_SIZE,
  defaultSortOrder = '',
  defaultSortField = '',
  defaultFilter = {},
  onRemove = () => {},
}: ListProps) => {
  const { params: initialParams } = useListUrlStoring();

  const { params, sortBy, searchBy, filterBy, goToPage, resetParamsToDefault } = useListParams({
    initialParams: { filter: initialParams.filter, sort: initialParams.sort },
    defaultSortOrder,
    defaultSortField,
    defaultFilter,
  });

  const { loading, loadData, setLoading } = useListDataLoading({ getDataMethod, resetParamsToDefault });

  const { data, reloadData } = useListDataUpdating({ loadData, params, pageSize });
  const listCrud = useListCrud({ onRemove, inputData: data });

  const contextData = {
    ...params,
    filterBy,
    sortBy,
    goToPage,
    searchBy,
    loading,
    setLoading,
    reloadData,
    uncontrolledFilters,
    ...listCrud,
  };

  return <ListProvider value={contextData}>{children}</ListProvider>;
};

export default ListWithoutStoringParams;
